import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiOrderHandlingRequirements extends Layout {
	labelNoneSelected: Label;
	panel1: Panel;
	sourceBrltlEdiOrderHdrXFgp: DataSource;
	sourceHandlingRequirements: DataSource;
	tblEdiHdrs: Table;
}
